import { createFileRoute } from "@tanstack/react-router";

import { TermsPage } from "@/components/marketing/terms-page";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/(public)/terms")({
  head: () => pageHead("terms"),
  component: TermsPage,
});
